import AIDesk from './aidesk';
import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
const messages = {
  fil: {
    "取消": 'Kanselahin',
    "确定": 'Kumpirmahin',
    "发送": 'Ipadala',
    "系统通知": 'Abiso ng Sistema',
    "关闭": 'Isara',
    "图片": 'Larawan',
    "文件": 'dokumento',
    "表情": 'Emoji',
    "视频": 'Bidyo',
    "录制": 'Magkuha ng audio',
    "拍照": 'Magkuha ng larawan',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;